<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_i"></a><em class="italic">The Civil War on the Water</em></h1>
<p class="subtitle">Favorite Stories and Fresh Perspectives from the Historians at Emerging Civil War</p>
<p class="author">Edited by</p>
<p class="author1">Dwight Sturtevant Hughes &amp; Chris Mackowski</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?1ff1803c